<template>
    <div class="plan">
        <div class="planItem" v-for="(item, index) in planList" :key="index">
            <div class="ItemTop">
                <div class="left">
                    <p>代理区域：{{item.provinceName}}-{{item.cityName}}-{{item.areaName}}</p>
                    <div class="value">
                        <p>区域分润值：</p>
                        <span>{{item.brokerage}}%</span>
                        <img src="../../../assets/images/ic_hint.png" @click="showTips" alt="">
                    </div>
                </div>
                <div class="status">
                    <span>{{getState(item.state)}}</span>
                </div>
            </div>
            <p class="time van-hairline--top">有效时间{{item.beginTime}}至{{item.endTime}}</p>
        </div>
    </div>
</template>

<script>
    /*
    * 区域代理列表
    * */
    import {getPlanList} from "../../../api/mine";

    export default {
        name: "Plan",
        data() {
            return {
                planList: []
            }
        },
        methods: {
            getState(state) {
                switch (state) {
                    case 'STATE_DOING':
                        return '进行中';
                    case 'STATE_WAITING':
                        return '待开始';
                    case 'STATE_SUCCESS':
                        return '已完成';
                    case 'STATE_CLOSED':
                        return '已关闭';
                }
            },
            showTips() {
                this.toast({
                    text: '平台分润的占比'
                })
            }
        },
        created() {
            getPlanList().then(res => {
                this.planList = res;
            })
        }
    }
</script>

<style lang='less' scoped>
    .plan {
        min-height: 100vh;
        padding-top: 2.67vw;
        background-color: #f7f7f7;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;

        .planItem {
            margin-bottom: 2.67vw;
            background-color: white;

            .ItemTop {
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 22.13vw;
                padding: 0 5.07vw 0 3.87vw;

                .status {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 19.6vw;
                    height: 6.67vw;
                    border-radius: 1.33vw;
                    border: solid 0.27vw #43a2fe;
                    font-size: 3.73vw;
                    color: #43a2fe;
                }

                .left {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-evenly;
                    height: 100%;
                    font-size: 3.73vw;
                    color: #333333;

                    .value {
                        display: flex;
                        align-items: center;

                        span {
                            font-size: 5.33vw;
                            color: #43a2fe;
                        }

                        img {
                            width: 3.07vw;
                            height: 3.07vw;
                            margin-left: 1.33vw;
                        }
                    }
                }
            }

            .time {
                text-indent: 3.87vw;
                line-height: 8.53vw;
                font-size: 2.93vw;
                color: #999999;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/mine/plan/Plan.vue